<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    #container
    [id]="id"
    class="agpr-iconDropdown-container"
>
    <div
        class="agpr-iconDropdown"
        [ngClass]="{'agpr-iconDropdown--socialPlus': agprStyle === agprComponentStyle.socialPlus}"
        [pTooltip]="inputTooltip | localize"
        tooltipPosition="top"
        [tooltipDisabled]="tooltipDisabled"
        (click)="onMouseclick($event)"
    >
        <input
            #focusInput
            readonly
            [id]="id + '_input'"
            type="text"
            role="combobox"
            class="u-srOnly agpr-iconDropdown--input"
            [agprTooltip]="inputTooltip"
            tooltipPosition="top"
            [attr.aria-expanded]="panelVisible"
            [attr.aria-haspopup]="'listbox'"
            [attr.aria-controls]="id + '_listbox'"
            (focus)="onInputFocus($event)"
            (blur)="onInputBlur($event)"
            (keydown)="onKeydown($event)"
            (keyup)="onKeyup($event)"
        >

        <span
            [class]="'agpr-iconDropdown-icon ' + displayIcon"
            aria-hidden="true"
        ></span>
        <span
            class="agpr-iconDropdown-triggerIcon fa-solid fa-angle-down"
            aria-hidden="true"
        ></span>
    </div>

    <div
        #panel
        class="agpr-iconDropdown-panel"
        [ngClass]="{'agpr-iconDropdown-panel--socialPlus': agprStyle === agprComponentStyle.socialPlus}"
        [@panelState]="panelVisible ? 'visible' : 'hidden'"
        [style.display]="panelVisible ? 'block' : 'none'"
        [id]="id + '.list'"
    >
        <div #itemswrapper>
            <ul
                role="listbox"
                [id]="id + '_listbox'"
                class="agpr-iconDropdown-panel-items agpr-clickOutsideExcluded"
                [attr.aria-label]="'Common.dropdown.listBoxAriaLabel' | localize"
            >
                <li
                    *ngFor="let option of options;let i = index"
                    role="option"
                    class="agpr-iconDropdown-item agpr-iconDropdown-panel-item"
                    [id]="id + '-dropdownOption-' + i"
                    [ngClass]="{
                        'agpr-iconDropdown-panel-focusedItem': i === focusedItemIndex,
                        'agpr-iconDropdown-panel-selectedItem': option.value === (bindToValue ? value : value?.value) && applyHighlight,
                    }"
                    [attr.aria-selected]="option.value === (bindToValue ? value : value?.value)"
                    (click)="onItemClick($event, i)"
                >
                    <span *ngIf="!itemTemplate">{{ option.label | localize }}</span>
                    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
                </li>
                <div *ngIf="customOptions?.length > 0" class="agpr-iconDropdown-customOptionSeparator"></div>
                <li
                    *ngFor="let customOption of customOptions; let i = index"
                    [id]="id + '_dropdownCustomOption_' + i"
                    class="agpr-iconDropdown-item agpr-iconDropdown-panel-item"
                    (click)="customOption.action()"
                >
                    <span>
                        {{ customOption.label | localize }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</div>
